<div class="dialog-main__container">
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">Change date of annulment</h3>
  </div>

  <div class="dialog-content__container">
    <app-datepicker
      [iconLeft]="true"
      [formControl]="annulment"
      [staticPropery]="true"
    >
    </app-datepicker>
  </div>

  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="close()">Cancel</button>
    </div>
  </div>
</div>
